export default __webpack_public_path__ + "static/media/GoldKidney.ec907046.jpg";